export const downloadBase64 = (data) => {

try{
        const fileName = `${data?.coursename}.${data?.fileExtension}`; // Change to the desired file name and extension
        //  const blob = new Blob([atob(result?.data)], { type: "application/octet-stream" }); // Decode Base64
        //  const url = window.URL.createObjectURL(blob);
        
        const a = document.createElement("a");
        a.href = data?.base64;
        a.download = fileName;
        a.click();
        a.remove()
    
    //  window.URL.revokeObjectURL(url);
}catch(e){
}
};

export const downloadFile = async ({ coursename, fileExtension, url }) => {
  try {
    const fileName = `${coursename || "brochure"}.${fileExtension || "pdf"}`;
 
    if (!url) {
      console.warn("⚠️ No URL provided for download");
      return;
    }
 
    // Fetch the file as blob
    const response = await fetch(url);
    const blob = await response.blob();
 
    // Create blob URL
    const blobUrl = window.URL.createObjectURL(blob);
 
    // Trigger download
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = fileName; // ✅ ensures browser saves file
    document.body.appendChild(a);
    a.click();
 
    // Cleanup
    a.remove();
    window.URL.revokeObjectURL(blobUrl);
  } catch (err) {
    console.error("Failed to trigger file download:", err);
  }
};
